import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";

function list(value) {
  return Array.isArray(value) ? value.map(String) : [];
}

function isEligible(item, { garmentId, sectionId, subsectionId, designId }) {
  const garments = list(item.compatibleGarmentIds || item.compatibleServiceIds);
  const sections = list(item.compatibleSectionIds);
  const subsections = list(item.compatibleSubsectionIds);
  const designs = list(item.compatibleDesignIds);
  return (!garments.length || garments.includes(garmentId)) &&
    (!sections.length || sections.includes(sectionId)) &&
    (!subsections.length || subsections.includes(subsectionId)) &&
    (!designs.length || designs.includes(designId));
}

export function listenToActiveAddOns(onSuccess, onError, context = {}) {
  let garmentContext = { garmentId: context.garmentId || "", sectionId: context.sectionId || "", subsectionId: context.subsectionId || "", designId: context.designId || "" };
  let addOns = [];
  const emit = () => onSuccess(addOns.filter((item) => isEligible(item, garmentContext)));
  if (garmentContext.garmentId) {
    getDoc(doc(db, "garments", garmentContext.garmentId)).then((snapshot) => {
      const data = snapshot.data() || {};
      garmentContext = {
        ...garmentContext,
        sectionId: data.sectionId || data.stitchingCategoryId || garmentContext.sectionId,
        subsectionId: data.subsectionId || garmentContext.subsectionId,
      };
      emit();
    }).catch(() => {});
  }
  return onSnapshot(collection(db, "addon"), (snapshot) => {
    addOns = snapshot.docs.map((document) => ({ id: document.id, ...document.data() }))
      .filter((item) => item.active === true)
      .sort((a, b) => Number(a.displayOrder || 0) - Number(b.displayOrder || 0));
    emit();
  }, onError);
}
